import React from 'react';
import { IBookingFlowProps } from 'src/components/BookingFlow/BookingFlow';
import { initialUserState } from 'src/components/UserDetails/UserDetails';
import { IBookingFlowState } from 'src/models/bookingFlow';
import { ReservationOrder } from 'src/entities/company';
import { IReservationModel } from 'src/entities/reservation';
import { IReservationEndUser } from 'src/entities/user';
import { StepType } from 'src/services/getStepOrder';

export interface IBookingFlowActions {
    setReservationEndUser: (value: IReservationEndUser) => void;
    handleUserChange: (value: any, name: string) => void;
    handleInvoiceChange: (value: any, name: string) => void;
    reloadReservations: (reservationOrder: ReservationOrder, newReservations: IReservationModel[]) => void;
    setReservationModel: (stepType: StepType, value: IReservationModel) => void;
    addNewReservation: () => void;
    removeReservation: (index?: number) => void;
    setActiveReservation: (index: number) => void;
    autoSelected: () => void;
}

export type IBookingFlowProvidedState = IBookingFlowState & IBookingFlowProps;

export const BookingContext = React.createContext<IBookingFlowProvidedState>({
    reservationEndUser: initialUserState,
    stepOrderTypes: [],
    reservations: [],
    activeReservationIndex: 0,
    actions: {
        setReservationEndUser: () => undefined,
        handleUserChange: () => undefined,
        handleInvoiceChange: () => undefined,
        reloadReservations: () => undefined,
        setReservationModel: () => undefined,
        addNewReservation: () => undefined,
        removeReservation: () => undefined,
        setActiveReservation: () => undefined,
        autoSelected: () => undefined
    },
    hasAutoSelected: false,
    activeStepIndex: 0,
    reservationOrder: ReservationOrder.CalendarFirst
});

export const BookingProvider = BookingContext.Provider;
export const BookingConsumer = BookingContext.Consumer;